import axios from "./axiosConfig";

export const saveFixationAttachment = async (dealId, fixationId, blob, filename) => {
  const base64Data = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(",")[1]);
    reader.onerror = () => reject(new Error("Unable to read the generated Fixation Note"));
    reader.readAsDataURL(blob);
  });
  const fields = new FormData();
  Object.entries({ documentType: "Fixation Note", fileName: filename,
    mimeType: filename.endsWith(".pdf") ? "application/pdf" : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    fileSize: blob.size, base64Data, remark: `Generated for fixation ${fixationId}`
  }).forEach(([key, value]) => fields.append(key, String(value)));
  await axios.post(`/sales-contract/attachments/deal/${dealId}/base64`, fields);
};
